import React from 'react';
import Form from './Form';
import { useParams } from 'react-router';
import { editAdmin } from '../../../Apis/adminApis';

export default function EditUser() {
    const { id } = useParams();
    // onsubmit
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        data.append("_method", "patch");
        return await editAdmin(id , data).then(res => {
            return 'done';          
        }).catch(err => {
            return err.response.data.errors;
        })
    };

    return (
        <Form onSubmit={onSubmit}></Form>
    )
}
